<template>
  <div :class="['Dialog tips', doubleBtn ? '' : 'end']" v-if="isShown">
    <div class="inner ">
      <i class="close" v-if="!isCloseHidden" @click="close"></i>
      <slot name="content"></slot>
      <div class="tips-btn">
        <slot name="button"></slot>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Prompt",
  props: ["isShown", "isCloseHidden", "doubleBtn"],
  data() {
    return {
      maskHeight: ""
    }
  },
  mounted() {
    this.maskHeight = document.documentElement.scrollHeight
  },
  methods: {
    close() {
      this.$emit("update:isShown", false)
    }
  }
}
</script>

<style scoped>
</style>
